import React, { useState, useRef, useMemo, useEffect } from 'react';
import { debounce } from 'lodash';

import CSSNumberValueControl from 'generics/components/css-number-value-control';

import { normalizeWidthHeightValues } from '../utilities';

import './index.scss';

function WidthHeightInput(props) {

  const [rootState, setRootState] = useState({
    values: normalizeWidthHeightValues(props.values)
  });

  const onChangeReference = useRef(props.onChange);
  onChangeReference.current = props.onChange;

  const onChangeHandler = useMemo(function createDebouncedHandler() {
    return debounce(function invokeLatestOnChange(values) {
      onChangeReference.current(values);
    }, 50);
  }, []);

  useEffect(function cancelOnUnmount() {
    return function onUnmount() {
      onChangeHandler.cancel();
    };
  }, [onChangeHandler]);

  function handleWidthValueChange(value, index) {

    const newValues = [...rootState.values];

    newValues[index] = value;

    const newValueObject = {
      width: newValues[0],
      height: newValues[1]
    };

    onChangeHandler(newValueObject);

    setRootState({
      ...rootState,
      values: [...newValues]
    });

  }

  function renderValueControl(index) {

    const value = rootState.values[index];
    const valueControlProperties = {
      value,
      onChange(value) {
        handleWidthValueChange(value, index);
      }
    };

    return <CSSNumberValueControl {...valueControlProperties} />;

  }

  function renderValueControlSection(index, label) {

    return <div className="side-value-control-section">

      <label className="side-value-control-label field-label">{label}</label>

      {renderValueControl(index)}

    </div>;

  }

  function renderMain() {

    const mainAttributes = {
      className: 'width-height-input-main'
    };

    return <div {...mainAttributes}>

      <div className="width-height-input-controls">

        {renderValueControlSection(0, 'WIDTH')}
        {renderValueControlSection(1, 'HEIGHT')}

      </div>

    </div>;

  }

  return renderMain();

}

export default WidthHeightInput;